import { getOnce } from '@/plugins/axios.js';

export default {
    async getApiSuppliers() {
        const response = await getOnce('v1/suppliers/api');

        return response?.data;
    },

    async getWebhookSuppliers(accountId: number | null) {
        const response = await getOnce('v1/suppliers/webhooks', {
            account_id: accountId,
        });

        return response?.data;
    },
};
